import { lazy } from "react";

const SystemLogisticsPage = lazy(() => import("@/widgets/system-admin/logistics/LogisticsPage"));
const SystemLogisticsProviderDetailPage = lazy(
  () => import("@/widgets/system-admin/logistics/LogisticsProviderDetailPage"),
);

const SystemLogisticsRoutes = {
  path: "logistics",
  children: [
    { index: true, element: <SystemLogisticsPage /> },
    { path: ":logisticsKey", element: <SystemLogisticsProviderDetailPage /> },
  ],
};

export default SystemLogisticsRoutes;
